import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatError, MatFormField, MatLabel, MatSelect } from '@angular/material/select';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';
import { FormlyFieldSelectProps, FormlySelectModule } from '@ngx-formly/core/select';
import { isEqual } from 'es-toolkit/compat';
import { CustomErrorStateMatcher } from '../utils/custom-error-state-matcher';

export interface ObjectSelectProps extends FormlyFieldProps, FormlyFieldSelectProps {}

export interface FormlyObjectSelectFieldConfig extends FormlyFieldConfig<ObjectSelectProps> {
  type: 'object-select' | Type<ObjectSelectComponent>;
}

@Component({
  selector: 'vectronic-formly-object-select',
  imports: [
    MatSelect,
    MatOption,
    MatLabel,
    MatFormField,
    MatError,
    ReactiveFormsModule,
    FormlyModule,
    AsyncPipe,
    FormlySelectModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <mat-form-field>
      <mat-label>{{ props?.label }}</mat-label>
      <mat-select
        [id]="id"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [placeholder]="props.placeholder!"
        [tabIndex]="props.tabindex"
        [required]="props?.required"
        [compareWith]="compareWith"
        [errorStateMatcher]="matcher"
      >
        @if (props.options | formlySelectOptions: field | async; as selectOptions) {
          @for (item of selectOptions; track item.label) {
            <mat-option [value]="item.value" [disabled]="item.disabled">{{
              item.label
            }}</mat-option>
          }
        }
      </mat-select>
      @if (showError) {
        <mat-error>
          <formly-validation-message [field]="field"></formly-validation-message>
        </mat-error>
      }
    </mat-form-field>
  `,
  styles: `
    mat-form-field {
      display: block;
    }
  `,
})
export class ObjectSelectComponent extends FieldType<FieldTypeConfig<ObjectSelectProps>> {
  matcher = new CustomErrorStateMatcher();

  compareWith(o1: { value: unknown; label: string }, o2: { value: unknown; label: string }) {
    return isEqual(o1, o2);
  }
}
